module.exports = __webpack_public_path__ + "img/af.2fdc7d0e.svg";